module.exports = __webpack_public_path__ + "static/media/gitgemsvid.ed8222f2.mp4";